import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useReferAndEarnPublicationFeedStore = defineSmartFeedPiniaStore("refer-and-earn-publication-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    feedUrl: "/publication/community/referals",
  }),
});
